<template>
  <b-modal id="location-picker-modal" size="lg">
    <div class="location-picker">
      <div>
        <div class="map-container">
          <div class="cross-icon" @click.stop="closeModal">
            <img src="@/assets/images/icons/cross-icon.svg" alt="cross-icon" />
          </div>
          <div class="search-input">
            <base-input
              id="location-picker-search-input"
              placeholder="search-for-location"
              :remove_default_margin="true"
              cus_style="padding:10px 35px 10px 10px;widht:250px;"
              field="search_text"
              :value="search_text"
              @change-value="setValue"
            >
              <template v-slot:attachment>
                <div class="search-prefix">
                  <img src="@/assets/images/icons/search-bar-icon.svg" alt="placeholder-add" />
                </div>
              </template>
            </base-input>
            <div class="suggestions-list" v-if="show_suggestions">
              <div
                v-for="(each, index) in suggestions"
                :key="index"
                class="suggestion p-1"
                @click.stop="selectSuggestion(each)"
              >
                <span>{{ each.place_name }}</span>
              </div>
            </div>
          </div>
          <div class="location-container" v-if="marker_name">
            <div class="title">{{ title }}</div>
            <div class="value">{{ marker_name }}</div>
          </div>
          <div id="map" style="height: 100%"></div>
        </div>
        <div class="border-container"></div>
        <div class="p-4 d-flex justify-content-end">
          <base-button
            id="location-picker-confirm-btn"
            variant="primary"
            cus_style="width:140px"
            @click="confirm"
            :disabled="!marker_name"
          >
            {{ $t('confirm') }}
          </base-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'

let map, start_marker, end_marker

export default {
  props: ['title', 'field', 'payload', 'show_picker'],
  emits: ['toggleShowLocationPicker', 'setMarker'],
  data() {
    return {
      marker: [],
      marker_name: '',
      search_text: '',
      suggestions: [],
      show_suggestions: false,
    }
  },
  methods: {
    setValue(val, field) {
      this[field] = val
    },
    closeModal() {
      this.marker = []
      this.marker_name = ''
      this.search_text = ''
      this.suggestions = []
      this.show_suggestions = false
      this.$emit('toggleShowLocationPicker')
      this.$bvModal.hide(`location-picker-modal`)
    },
    confirm() {
      this.$emit('setMarker', this.marker, this.marker_name)
      this.closeModal()
    },
    mapClick(e) {
      this.marker = [e.lngLat.lng, e.lngLat.lat]
      this.setMarker()
    },
    setMarker() {
      if (this.field === 'start') {
        const start_marker_el = document.createElement('div')
        start_marker_el.className = 'pin-marker'
        if (start_marker) start_marker.remove()
        start_marker = new mapboxgl.Marker(start_marker_el).setLngLat(this.marker).addTo(map)

        map.flyTo({
          center: this.marker,
          essential: true,
        })
      } else if (this.field === 'end') {
        const start_marker_el = document.createElement('div')
        start_marker_el.className = 'start-marker'
        if (start_marker) start_marker.remove()
        start_marker = new mapboxgl.Marker(start_marker_el)
          .setLngLat(this.payload.start.location)
          .addTo(map)

        const end_marker_el = document.createElement('div')
        end_marker_el.className = 'pin-marker'
        if (end_marker) end_marker.remove()
        end_marker = new mapboxgl.Marker(end_marker_el).setLngLat(this.marker).addTo(map)

        map.fitBounds([this.payload.start.location, this.marker])
        this.getGoogleRoute(this.payload.start.location, this.marker, map)
      }
    },
    mapboxSelectSuggestion(data) {
      this.search_text = data.place_name
      this.marker = data.center
      map.flyTo({
        center: data.center,
        essential: true,
      })
      this.setMarker()
      setTimeout(() => {
        this.show_suggestions = false
      }, 500)
    },
    async mapboxGetRoute(start, end) {
      const query = await fetch(
        `https://api.mapbox.com/directions/v5/mapbox/driving/${start[0]},${start[1]};${end[0]},${end[1]}?steps=true&geometries=geojson&access_token=${this.$config.mapBoxPK}`,
        { method: 'GET' }
      )
      const json = await query.json()
      const data = json.routes[0]
      const route = data.geometry.coordinates
      const geojson = {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'LineString',
          coordinates: route,
        },
      }

      if (map.getSource('route')) {
        map.getSource('route').setData(geojson)
      } else {
        map?.addLayer({
          id: 'route',
          type: 'line',
          source: {
            type: 'geojson',
            data: geojson,
          },
          layout: {
            'line-join': 'round',
            'line-cap': 'round',
          },
          paint: {
            'line-color': '#2BCBDB',
            'line-width': 5,
            'line-opacity': 1,
          },
        })
      }
    },
    async mapboxSearchPlace() {
      const query = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.search_text}.json?access_token=${this.$config.mapBoxPK}`,
        { method: 'GET' }
      )
      const json = await query.json()
      if (json.features.length) {
        this.suggestions = json.features

        this.show_suggestions = true
      }
    },
    async getMarkerInfo() {
      const query = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.marker[0]},${this.marker[1]}.json?access_token=${this.$config.mapBoxPK}`,
        { method: 'GET' }
      )
      const json = await query.json()
      if (json.features.length) this.marker_name = json.features[0].place_name
    },
    async searchPlace() {
      this.suggestions = await this.searchGooglePlace(this.search_text)
      if (this.suggestions.length) this.show_suggestions = true
    },
    async selectSuggestion(data) {
      this.search_text = data.place_name
      this.marker = await this.getGoogleLatLng(data, map)
      this.setMarker()
      setTimeout(() => {
        this.show_suggestions = false
      }, 0)
    },
  },
  watch: {
    search_text(val) {
      if (val.length) this.searchPlace()
    },
    marker(val) {
      if (val.length) {
        this.marker_name = ''
        this.getMarkerInfo()
      }
    },
    show_picker(val) {
      if (val)
        setTimeout(() => {
          if (document.getElementById('map')) {
            mapboxgl.accessToken = this.$config.mapBoxPK

            // Check if the RTL plugin has already been loaded
            if (mapboxgl.getRTLTextPluginStatus() === 'unavailable') {
              mapboxgl.setRTLTextPlugin(
                'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
                null,
                true // Lazy load the plugin
              )
            }
            map = new mapboxgl.Map({
              container: 'map',
              style: 'mapbox://styles/mapbox/streets-v12',
              center: [46.715022884817245, 24.642516582053403],
              zoom: 8,
              language: this.isLangRtl ? 'ar' : 'en',
            })

            map.on('click', (e) => {
              this.mapClick(e)
            })

            map.on('style.load', async () => {
              if (
                this.payload &&
                this.payload[this.field] &&
                this.payload[this.field]['name'] &&
                this.payload[this.field]['location'] &&
                this.payload[this.field]['location'].length
              ) {
                if (this.field === 'start') {
                  this.marker_name = this.payload[this.field]['name']
                  this.marker = this.payload[this.field]['location']

                  const start_marker_el = document.createElement('div')
                  start_marker_el.className = 'pin-marker'
                  if (start_marker) start_marker.remove()
                  start_marker = new mapboxgl.Marker(start_marker_el)
                    .setLngLat(this.payload.start.location)
                    .addTo(map)

                  map.flyTo({
                    center: this.payload.start.location,
                    essential: true,
                  })
                } else if (this.field === 'end') {
                  this.marker_name = this.payload[this.field]['name']
                  this.marker = this.payload[this.field]['location']

                  const start_marker_el = document.createElement('div')
                  start_marker_el.className = 'start-marker'
                  if (start_marker) start_marker.remove()
                  start_marker = new mapboxgl.Marker(start_marker_el)
                    .setLngLat(this.payload.start.location)
                    .addTo(map)

                  const end_marker_el = document.createElement('div')
                  end_marker_el.className = 'pin-marker'
                  if (end_marker) end_marker.remove()
                  end_marker = new mapboxgl.Marker(end_marker_el)
                    .setLngLat(this.payload.end.location)
                    .addTo(map)

                  map.fitBounds([this.payload.start.location, this.payload.end.location])
                  await this.getGoogleRoute(
                    this.payload.start.location,
                    this.payload.end.location,
                    map
                  )
                }
              }
            })
          }
        }, 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.location-picker {
  .map-container {
    height: 400px;
    position: relative;
    z-index: 24;
    .cross-icon {
      z-index: 25;
      position: absolute;
      cursor: pointer;
      inset-inline-end: 20px;
      top: 20px;

      img {
        height: 15px;
        width: 15px;
      }
    }
    .search-input {
      z-index: 25;
      position: absolute;
      inset-inline-start: 20px;
      top: 30px;
    }

    .search-prefix {
      position: absolute;
      top: 8px;
      inset-inline-end: 10px;
    }

    .suggestions-list {
      background-color: var(--color-01);
      width: 250px;
      max-height: 200px;
      overflow: auto;
      .suggestion {
        font-size: 14px;
        color: var(--color-13);
        cursor: pointer;
      }
    }

    .suggestions-list::-webkit-scrollbar {
      width: 5px;
    }

    .suggestions-list::-webkit-scrollbar-track {
      background: var(--color-44);
    }

    .suggestions-list::-webkit-scrollbar-thumb {
      background: var(--color-23);
    }

    .suggestions-list::-webkit-scrollbar-thumb:hover {
      background: var(--color-45);
    }
    .location-container {
      z-index: 25;
      position: absolute;
      left: 35%;
      top: 20px;
      padding: 0.25rem;
      background: var(--color-01);
      box-shadow: 0px 12px 16px var(--color-38);
      text-align: center;
      width: 250px;
      .title {
        font-weight: 700;
        font-size: 14px;
        color: var(--color-23);
      }
      .value {
        font-size: 14px;
        color: var(--color-13);
      }
    }
  }
  .border-container {
    border: 1px solid var(--color-23);
  }
}
</style>

<style lang="scss">
.pin-marker {
  background-image: url('@/assets/images/icons/pin-marker.svg');
  background-size: cover;
  width: 30px;
  height: 50px;
  cursor: pointer;
}

.start-marker {
  background-image: url('@/assets/images/icons/start-marker.svg');
  background-size: cover;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.modal-body {
  padding: 0px !important;
}
</style>
